<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="block_1 flex-row">
        <div class="block_2 flex-col justify-between">
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/pso6zxs1z989tnul6vcd6gapti7bbf4e27283b1d-2d20-4ec4-8b6c-d3e0cd0fd4e2"
          />
          <div class="text-wrapper_1 flex-row justify-between">
            <span class="text_01">{{ y1 }}</span>
            <span class="text_01">{{ y2 }}</span>
          </div>
        </div>
        <div class="text-wrapper_2 flex-col">
          <span class="text_3">机器人巡场报告</span>
        </div>
        <div class="block_3 flex-col justify-between">
          <div class="section_1 flex-row justify-between">
            <img
              class="image_2"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/psbak71jwqfusua3ezbvggvrntl3e6oucze64aa767-321c-4336-a3b7-517a95dbe1e1"
            />
            <span class="text_4">元通智能</span>
          </div>
          <router-link :to="{ name: 'view5', query: { robotId: this.robotId } }"
          ><button class="homeBtn">首页</button></router-link
          >
          <router-link :to="{ name: 'view12', query: { robotId: this.robotId } }"
            ><button class="leftBtn">返回上页</button></router-link
          >
          <!-- <span class="text_5">乌山九巷B1停车场</span> -->
        </div>
      </div>
      <div class="block_4 flex-row">
        <div class="box_1 flex-row">
          <!-- <span class="text_6">查找车位</span> -->
          <input
            type="text"
            class="text_21"
            placeholder="查找车位"
            @input="jianting"
            v-model="carSpace"
          />
          <div class="image-wrapper_1 flex-col shouzhi" @click="searchSpace">
            <img
              class="thumbnail_1"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/psxqlkpfdjq652mtofx1c74ezdsyhvzisi121877a2-5f45-45d2-b9a9-4260ce1a27b3"
            />
          </div>
        </div>
        <div
          class="image-text_1 flex-row justify-between shouzhi"
          v-show="showTrue"
          @click="viewPhoto"
        >
          <img
            class="label_1"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps11bp0lb8p4dlr0rtnyoqwpukohx3ks4ef5e2d2202-394d-465d-8b60-49834bff20d3"
          />
          <span class="text-group_1">机器人拍照照片</span>
        </div>
        <div class="image-text_2 flex-col" v-show="showTrue">
          <div class="text-wrapper_3 flex-row">
            <span class="text-group_2"
              >{{ parkMessage.parkName }}停车场车位实时总数据（{{
                y3
              }}更新）</span
            >
          </div>
          <div class="group_2 flex-row">
            <div class="image-wrapper_2 flex-col align-center">
              <img
                class="thumbnail_2"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psoai3xfvnmzj30ok9w8fuzf6mcmisccpm7427576f9-fe3d-471d-878f-e5a8d37ed569"
              />
            </div>
          </div>
        </div>
        <div class="box_2 flex-col">
          <div class="text-wrapper_4 flex-col">
            <span class="text_7"
              >{{nowQuest.startTime}}&nbsp;机器人巡场路线</span
            >
          </div>
          <!-- <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/psof31p984qap78ee67x2h15tiymmg1yf9hae218306-fbe4-4ac0-a21d-b065e5180044"
          /> -->
          <!-- <img
            class="image_4"
            referrerpolicy="no-referrer"
            :src="mapImageSrc"
          /> -->
          <canvas
            ref="canvasPoint"
            class="image_4"
            :style="{
              backgroundImage: `url(${mapImageSrc})`,
            }"
            :width="kuandu"
            height="516"
          ></canvas>
        </div>
      </div>
      <div class="block_5 flex-row" v-show="showTrue">
        <div class="group_3 flex-col justify-between">
          <!-- <div class="text-wrapper_5 flex-row">
            <span class="text_8">车位号</span>
            <span class="text_9">车牌号码</span>
            <span class="text_10">停放状态</span>
          </div> -->
          <dv-scroll-board :config="config" class="left2center_col3table" />
        </div>
        <div class="group_4 flex-col justify-between">
          <div class="box_3 flex-col"></div>
          <div class="box_4 flex-col"></div>
          <div class="box_5 flex-col"></div>
          <div class="box_6 flex-col"></div>
          <div class="box_7 flex-col"></div>
          <div class="box_8 flex-col"></div>
        </div>
        <div class="text-wrapper_11 flex-col justify-between">
          <span class="text_26">车场总车位数</span>
          <span class="text_27">当前在停车辆</span>
          <span class="text_28">业主在停</span>
          <span class="text_29">临停车辆在停</span>
          <span class="text_30">长租车在停</span>
          <span class="text_31">短租车在停</span>
        </div>
        <div class="text-wrapper_12 flex-col justify-between">
          <span class="text_32">&nbsp;{{ parkMessage.total }}</span>
          <span class="text_33">&nbsp;{{ parkMessage.parking }}</span>
          <span class="text_34">&nbsp;{{ parkMessage.parkingOwner }}</span>
          <span class="text_35">&nbsp;{{ parkMessage.temporaryParking }}</span>
          <span class="text_36">&nbsp;{{ parkMessage.longTermLease }}</span>
          <span class="text_37">&nbsp;{{ parkMessage.shortTermLease }}</span>
        </div>
        <div class="group_5 flex-col justify-between">
          <div class="box_9 flex-col"></div>
          <div class="box_10 flex-col"></div>
          <div class="box_11 flex-col"></div>
          <div class="box_12 flex-col"></div>
        </div>
        <div class="text-wrapper_13 flex-col">
          <span class="text_38">其余在停车辆</span>
          <span class="text_39">当前无车停放车位</span>
          <span class="text_40">当前车位被占</span>
          <span class="text_41">未正确停放车辆</span>
        </div>
        <div class="text-wrapper_14 flex-col justify-between">
          <span class="text_42">&nbsp;{{ parkMessage.remaining }}</span>
          <span class="text_43">&nbsp;{{ parkMessage.noParking }}</span>
          <span class="text_44">&nbsp;{{ parkMessage.occupied }}</span>
          <span class="text_45">&nbsp;{{ parkMessage.errorParking }}</span>
        </div>
        <div class="group_6 flex-col">
          <span class="text_46">车场车辆停放数量</span>
          <div id="bingtu" class="bingtu"></div>
        </div>
      </div>
      <div class="block_5 flex-row" v-show="showTrue == false">
        <div class="xgroup_4 flex-col">
          <div class="xtext-wrapper_3 flex-row">
            <span class="text_7">{{ basicInformation.carNo }}基本信息</span>
          </div>
          <div class="xbox_4 flex-row">
            <div class="xbox_5 flex-col"></div>
            <span class="xtext_8">车位属性</span>
            <span class="xtext_9">{{ basicInformation.spaceStats }}</span>
          </div>
          <div class="xbox_6 flex-row">
            <div class="xgroup_5 flex-col"></div>
            <span class="xtext_10">使用情况</span>
            <span class="xtext_11">{{ basicInformation.useSituation }}</span>
          </div>
          <div class="xbox_7 flex-row">
            <div class="xsection_6 flex-col"></div>
            <span class="xtext_12">收益率</span>
            <span class="xtext_13">{{ basicInformation.earningsRate }}</span>
          </div>
          <div class="xbox_8 flex-row">
            <div class="xbox_9 flex-col"></div>
            <span class="xtext_14">使用率</span>
            <span class="xtext_15">{{ basicInformation.useRate }}</span>
          </div>
          <div class="xbox_10 flex-col"></div>
          <div class="xbox_11 flex-col"></div>
          <div class="xbox_12 flex-col"></div>
          <div class="xbox_13 flex-col"></div>
        </div>

        <div class="xtimeLine">
          <div class="titleToday">
            {{ carSpace }} 车位今日停车情况时间线
          </div>
          <div class="allDay">
            <div class="nowTime" :style="{ width: nowTime + 'px' }">
              <!-- <div class="timePoint"></div> -->
              <div
                v-for="(item, index) in items"
                class="timePoint"
                :key="index"
                :id="'item-' + index"
                :style="item.hourPoint"
                @mouseover="showPopup(item)"
                @mouseleave="hidePopup"
              ></div>
            </div>
          </div>

          <div v-if="showPopupFlag" class="popupCar">
            <img :src="carSpaceTime.imgSrcUrl" alt="" class="carPhoto" />
            <div class="pzTime">巡查时间:{{ carSpaceTime.time }}</div>
            <div class="carType">{{ carSpaceTime.carType }}</div>
            <div class="carNoNo">{{ carSpaceTime.carNo }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="restartWinBg" v-if="bgDiog">
      <div class="photobox_6 flex-col">
        <div class="photosection_2 flex-row">
          <!-- <div class="photoimage-wrapper_5 flex-col align-center">
            <img
              class="photothumbnail_3"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps85d0z60qn7jm99g3w72ihgc8uu00k524ue95005a9-2438-4c14-ab92-bde31a1d7600"
            />
          </div> -->
          <span class="phototext_26"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
          <img
            class="photolabel_6"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/psspp0ljwitojs1ejmtz5hzrf4mgyr1njkb21c5864-b750-427e-8362-5650e7fb36de"
            @click="viewPhotoFalse"
          />
        </div>
        <div class="thumb-example">
          <swiper
            class="swiper gallery-top"
            :options="swiperOptionTop"
            ref="swiperTop"
          >
            <swiper-slide
              class="slide-1"
              v-for="(item, index) in bigImg"
              :key="index"
            >
              <img :src="item" style="height: 570px; width: 100%" alt="" />
            </swiper-slide>
            <div
              class="swiper-button-next swiper-button-white"
              slot="button-next"
            ></div>
            <div
              class="swiper-button-prev swiper-button-white"
              slot="button-prev"
            ></div>
          </swiper>

          <swiper
            class="swiper gallery-thumbs"
            :options="swiperOptionThumbs"
            ref="swiperThumbs"
          >
            <swiper-slide
              class="slide"
              style="width: 100px; height: 100px"
              v-for="(item, index) in bigImg"
              :key="index"
            >
              <img style="width: 98px; height: 98px" :src="item" alt="" />
            </swiper-slide>
            <div
              class="swiper-button-next swiper-button-white"
              slot="button-next"
            >
              <div>
                <img src="../assets/you.png" alt="" />
              </div>
            </div>
            <div
              class="swiper-button-prev swiper-button-white"
              slot="button-prev"
            >
              <div>
                <img src="../assets/zuo.png" alt="" />
              </div>
            </div>
          </swiper>
        </div>
        <div class="photosection_3 flex-row justify-between">
          <!-- <div class="photoimage-wrapper_6 flex-row">
            <img
              class="photoimage_12"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/psenw6380kne5euly4l7myejikd43v00m851f1d1d-c5a6-4ca7-827d-21dd0302be38"
            />
            <img
              class="photoimage_13"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps222izwcii0q8zdl1b3tkyirbohgzmtrom41436f74-2836-4cc1-8f1a-5ef504db69bd"
            />
          </div> -->
          <div class="photobox_7 flex-col justify-between">
            <span class="phototext_27">选择日期</span>
            <div class="photoblock_9 flex-col">
              <!-- <div class="photogroup_15 flex-row">
                <div class="phototext-wrapper_11 flex-col">
                  <span class="phototext_28">2022-11-01&nbsp;</span>
                  <span class="phototext_29">2022-11-01&nbsp;</span>
                  <span class="phototext_30">2022-11-01&nbsp;</span>
                  <span class="phototext_31">2022-11-01&nbsp;</span>
                  <span class="phototext_32">2022-11-01&nbsp;</span>
                  <span class="phototext_33">2022-11-01&nbsp;</span>
                  <span class="phototext_34">2022-11-01&nbsp;</span>
                </div>

                <div class="photobox_8 flex-col">
                  <div class="photoblock_10 flex-col"></div>
                </div>
              </div>
              <div class="phototext-wrapper_12 flex-row">
                <span class="phototext_35">2022-11-01&nbsp;</span>
              </div>
              <div class="phototext-wrapper_13 flex-row">
                <span class="phototext_36">2022-11-01&nbsp;</span>
              </div> -->
              <div class="more-text-content">
                <vue-scroll ref="scrollNoticeDetails">
                  <div class="details-content">
                    <div
                      class="details-conten-item"
                      v-for="(item, index) in timeList"
                      :class="{ selected: selectedIndex === index }"
                      @click="selectItem(index)"
                    >
                      {{ item }}
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="photosection_4 flex-row">
          <img
            class="photoimage_14"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/pslskeqt7n4afrhnzy96d8zwmve2yvphx0101c424-b505-433a-b939-96ef912b4936"
          />
          <div class="photoimage-wrapper_7 flex-row">
            <img
              class="photoimage_15"
              referrerpolicy="no-referrer"
              :src="item.lanhuimage0"
              v-for="(item, index) in loopData0"
              :key="index"
            />
          </div>
          <img
            class="photoimage_16"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/psvv2ot21m1b1zwh79k0qrcuam0tp1b93l0d7bcd82-9fb8-4df3-b981-6b3250a4e7d0"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
var that;
var interval1;
var interval2;
var interval3;
var echarts1;
var option1;
import { get, post } from "@/util/axios";
export default {
  data() {
    return {
      y1: "",
      y2: "",
      y3: "",
      robotId: 0,
      nowQuest: {},
      mapImageSrc: "",
      kuandu: null,
      yuantuHeight: null,
      robotPointAdr: [],
      regularParkingList:[],
      illegalParkingList:[],
      vehiclePosition:null,
      parkMessage: {},
      nowTime: "",
      carSpace: "",
      showTrue: true,

      config: {
        header: ["车位号", "车牌号", "停放状态"],
        data: [],
        align: ["center", "center", "center"],
        columnWidth: [200, 280, 320],
        headerBGC: "transparent",
        oddRowBGC: "transparent",
        evenRowBGC: "transparent",
      },
      bingshuzhi: [
        { value: null, name: "业主在停" },
        { value: null, name: "临停车辆在停" },
        { value: null, name: "长租车在停" },
        { value: null, name: "短租车在停" },
        { value: null, name: "其余在停车辆" },
      ],

      basicInformation: {
        spotNo: "A2-121",
        spaceStats: "业主车位",
        useSituation: "租赁中",
        earningsRate: "66%",
        useRate: "88%",
      },
      items: [],
      loopData0: [
        {
          lanhuimage0:
            "https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/88f83dc27735449b91d4dea226943e34_mergeImage.png",
        },
        {
          lanhuimage0:
            "https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/b281e24ad10840308d0880a90a35724e_mergeImage.png",
        },
        {
          lanhuimage0:
            "https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/8eda52346ed047639bc7eda80183e5a5_mergeImage.png",
        },
        {
          lanhuimage0:
            "https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/41314bf5ad6b4c5bb8efac4aebaff9d3_mergeImage.png",
        },
        {
          lanhuimage0:
            "https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/c9edc2cb17564f22b9ae4cf0e3c072ac_mergeImage.png",
        },
      ],
      showPopupFlag: false,
      carSpaceTime: {
        time: "",
        imgSrcUrl: "",
        carNo: "",
        carType: "",
      },

      option1: {},
      bgDiog: false,
      timeList: [],
      bigImg: [],
      bigImgList: [],
      selectedIndex: 0,
      swiperOptionTop: {
        zoom: true,
        loop: false,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // autoplay: {  //自动轮播
        //   delay: 2000,
        //   disableOnInteraction: false
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionThumbs: {
        loop: false,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  watch: {
    showTrue() {
      this.getThreeMovePoint();
      if (!this.showTrue) {
        this.hidePopup();
        this.items.forEach((item, index) => {
          this.showPopup(item);
          setTimeout(() => {
          }, 1000); // 500 毫秒，即半秒
        });
      }
    },
    vehiclePosition() {
      this.getThreeMovePoint();
      if (!this.showTrue) {
        this.hidePopup();
        this.items.forEach((item, index) => {
          this.showPopup(item);
          setTimeout(() => {
          }, 1000); // 500 毫秒，即半秒
        });
      }
    },
  },
  created() {
    if (this.$route.query.robotId) {
      this.robotId = this.$route.query.robotId;
    }
  },
  beforeDestroy() {
    // 清除所有定时器
    if (interval1) {
      clearInterval(interval1);
      interval1 = null;
    }
    if (interval2) {
      clearInterval(interval2);
      interval2 = null;
    }
  },
  mounted() {
    that = this;
    interval1 = setInterval(function () {
      that.getTime();
    }, 1000);
    interval2 = setInterval(function () {
      that.taskInfo();
      that.getThreeMovePoint();
      that.parkInfo();
      that.xunchangxinxi();
      that.getTime2();
    }, 20000);
    interval3 = setInterval(function () {
      that.getPatrolTaskPic()
    }, 60000);

    that.taskInfo();
    that.getThreeMovePoint();
    that.parkInfo();
    that.xunchangxinxi();
    that.getThreeMap();
    that.getTime2();
    that.getPatrolTaskPic();
    // 实现swiper双向控制
  },
  methods: {
    processX(x,y) {
      let result = 0;
      if (this.robotId == '3' || this.robotId == '4') {
        result = 1956.481 -30.653 * parseFloat(x) -1.484 * parseFloat(y);
      } else if (this.robotId == '5') {
        // result = 470.02 - 1.65 * parseFloat(x) + 28.37 * parseFloat(y);
        result = 1.3600 * parseFloat(x) + 28.0353 * parseFloat(y) + 516.9969;
      }else if (this.robotId == '6') {
        result = 32.19 * parseFloat(x) + 0.27 * parseFloat(y) + 654.13;
      }
      return parseFloat(result.toFixed(1));
    },
    processY(x,y) {
      let result = 0;
      if (this.robotId == '3' || this.robotId == '4') {
        result = -0.487 * parseFloat(x) + 26.395 * parseFloat(y) + 1213.689;
      } else if (this.robotId == '5') {
        // result = 634.01 + 21.81 * parseFloat(x) + 0.88 * parseFloat(y);
        result = 21.8067 * parseFloat(x) - 1.1227 * parseFloat(y) + 685.5309
      }else if (this.robotId == '6') {
        result =0.22 * parseFloat(x) - 24.47 * parseFloat(y) + 1792.07
      }
      return parseFloat(result.toFixed(1));
    },
    taskInfo() {
      console.log("获取任务");
      get(`/threeBigscreen/taskInfo/${this.robotId}`, {})
        .then((res) => {
          this.nowQuest = res.data;
        });
    },
    async  getThreeMovePoint() {
      console.log("加载行走路线");
      that = this;
      const self = this;
      let data;
      try {
        // 等待异步请求完成
        const res = await get(`/threeBigscreen/taskInfo/${this.robotId}`, {});
        data = res.data;
      } catch (error) {
        console.error("请求出错:", error);
        return;
      }
      // 将第一个时间字符串转换为时间戳
      const date1 = new Date(data.startTime.replace(" ", "T")); // 替换空格以适配 Date 格式
      const timestamp1 = Math.floor(date1.getTime()); // 转换为秒级时间戳
      // 从第二个字符串解析天、小时、分钟
      const days = parseInt(data.duration.match(/(\d+)天/)[1], 10) || 0;
      const hours = parseInt(data.duration.match(/(\d+)小时/)[1], 10) || 0;
      const minutes = parseInt(data.duration.match(/(\d+)分钟/)[1], 10) || 0;
      const timeDelta = (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60) * 1000;
      const timestamp2 = Math.floor((date1.getTime() + timeDelta));
      get("/threeBigscreen/getThreeMovePointByTime", {
        robotId: this.robotId,
        startTime:timestamp1,
        endTime:timestamp2
      }).then((res) => {

        this.robotPointAdr = res.data.pointList;
        const newXunipoint = this.robotPointAdr.map((point) => ({
          pointX: (self.processX(point.pointX,point.pointY)/ that.yuantuHeight),
          pointY: (self.processY(point.pointX,point.pointY) / that.yuantuHeight),
          pointYaw:parseFloat(point.pointYaw),
        }));
        const canvas = that.$refs.canvasPoint;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const points = newXunipoint;
        ctx.beginPath();
        const arrowWidth = 5;
        ctx.moveTo(points[0].pointX, points[0].pointY);
        for (let i = 1; i < points.length; i++) {
          ctx.lineTo(points[i].pointX, points[i].pointY);
        }

        ctx.lineWidth = 1;
        ctx.strokeStyle = "red";
        // ctx.lineTo(-arrowWidth, -arrowWidth);
        // ctx.lineTo(-arrowWidth, arrowWidth);
        // ctx.lineTo(0, 0);
        // ctx.lineTo(0, -arrowWidth);

        ctx.stroke();
        const lastPoint = points[points.length - 1];
        const lastX = lastPoint.pointX;
        const lastY = lastPoint.pointY;
        const yaw = lastPoint.pointYaw;

        const img = new Image();
        // img.src = "https://lanhu.oss-cn-beijing.aliyuncs.com/psp6d5rfoa3upk47uaszkh9fkgn8e0tk837749eb-c282-4c30-b38c-32fb678ac6aa";
        // img.referrerPolicy = 'no-referrer';
        img.src = require('@/assets/location.png');
        const robotId = this.robotId;
        img.onload = function() {
          // 图片的尺寸设置为你需要的宽度和高度，这里我设定为50x50
          const imgWidth = 22;
          const imgHeight = 22;
          // 保存当前画布状态
          ctx.save();
          // 设置旋转中心为图片的中心
          ctx.translate(lastX, lastY); // 将坐标系移动到图片的中心
           // 旋转角度，转换为弧度
          console.log(robotId)
          if(robotId===4){
            ctx.rotate(2*Math.PI-yaw+180);
          }else{
            ctx.rotate(2*Math.PI-yaw);
          }

          // 绘制图片，使用图片的中心坐标
          ctx.drawImage(img, -imgWidth / 2, -imgHeight / 2, imgWidth, imgHeight);
          // 恢复画布状态
          ctx.restore();
          // ctx.drawImage(img, lastX - imgWidth / 2, lastY - imgHeight / 2, imgWidth, imgHeight);
        }




        function convertToCanvasCoordinates(rectangle) {
          return rectangle.map((point) => ({
            pointX: (self.processX(point.x,point.y) / that.yuantuHeight),
            pointY: (self.processX(point.x,point.y) / that.yuantuHeight),
          }));
        }

        // 绘制矩形
        function drawRectangle(rectPoints, fillColor, strokeColor) {
          const [topLeft, topRight, bottomRight, bottomLeft] = rectPoints;

          ctx.beginPath();
          ctx.moveTo(topLeft.pointX, topLeft.pointY);
          ctx.lineTo(topRight.pointX, topRight.pointY);
          ctx.lineTo(bottomRight.pointX, bottomRight.pointY);
          ctx.lineTo(bottomLeft.pointX, bottomLeft.pointY);
          ctx.closePath(); // 关闭路径，自动连接最后一个点和第一个点

          ctx.fillStyle = fillColor; // 填充颜色
          ctx.fill(); // 填充矩形

          // 绘制矩形边框
          ctx.lineWidth = 2;
          ctx.strokeStyle = strokeColor;
          ctx.stroke();
        }

        //绘制搜索出来的车位
        if (!this.showTrue) {
          const RedRectangle = [
            { x: this.vehiclePosition.parkX1, y: this.vehiclePosition.parkY1 },
            { x: this.vehiclePosition.parkX2, y: this.vehiclePosition.parkY2 },
            { x: this.vehiclePosition.parkX3, y: this.vehiclePosition.parkY3 },
            { x: this.vehiclePosition.parkX4, y: this.vehiclePosition.parkY4 }
          ];
          const canvasRect = convertToCanvasCoordinates(RedRectangle);
          drawRectangle(canvasRect, 'red', 'white');
        }

        //绘制临停车
        const blueRectangles = this.regularParkingList.map((spot) => {
          return [
            {x: spot.parkX1, y: spot.parkY1},
            {x: spot.parkX2, y: spot.parkY2},
            {x: spot.parkX3, y: spot.parkY3},
            {x: spot.parkX4, y: spot.parkY4}
          ];
        });
        blueRectangles.forEach((rect) => {
          const canvasRect = convertToCanvasCoordinates(rect);
          drawRectangle(canvasRect, 'blue', 'white');
        });

        //绘制违停车
        const yellowRectangles = this.illegalParkingList.map((spot) => {
          return [
            {x: spot.parkX1, y: spot.parkY1},
            {x: spot.parkX2, y: spot.parkY2},
            {x: spot.parkX3, y: spot.parkY3},
            {x: spot.parkX4, y: spot.parkY4}
          ];
        });
        yellowRectangles.forEach((rect) => {
          const canvasRect = convertToCanvasCoordinates(rect);
          drawRectangle(canvasRect, 'yellow', 'white');
        });

      });
    },
    getThreeSpot() {
      console.log("车位信息");
      get("/threeBigscreen/getThreeSpot", {
        robotId: this.robotId
      }).then((spotRes) => {
        this.regularParkingList = spotRes.data[0];
        this.illegalParkingList = spotRes.data[1];
      });
    },
    getThreeMap() {
      console.log("加载地图");
      get("/threeBigscreen/getThreeMap", {
        robotId: this.robotId,
      }).then((res) => {
        this.mapImageSrc = res.data.mapUrl;
        this.yuantuHeight = (res.data.mapY / 516);
        this.kuandu = (res.data.mapX / this.yuantuHeight).toFixed(2);
      });
    },
    xunchangxinxi() {
      console.log("全部车位");
      get("/threeBigscreen/getSpotList", {
        robotId: this.robotId,
      }).then((res) => {
        let list = [];
        let list1 = res.data;
        let a = [];
        list1.forEach((item, index) => {
          a.push(item.parkSpotNo);
          a.push(item.carNo);

          if (item.warnType == 0) {
            a.push("正常");
          } else if (item.warnType == 1) {
            a.push("违停");
          } else if (item.warnType == 2) {
            a.push("被占");
          } else if (item.warnType == 3) {
            a.push("超期");
          }
          list.push(a);
          a = [];
        });
        let da = JSON.parse(JSON.stringify(this.config));
        this.config = da;
        da.data = list;
      });
    },
    parkInfo() {
      console.log("加载停车场信息");
      get("/threeBigscreen/parkInfo/" + this.robotId, {}).then((res) => {
        this.parkMessage = res.data;

        this.bingshuzhi[0].value = res.data.parkingOwner;
        this.bingshuzhi[1].value = res.data.temporaryParking;
        this.bingshuzhi[2].value = res.data.longTermLease;
        this.bingshuzhi[3].value = res.data.shortTermLease;
        this.bingshuzhi[4].value = res.data.remaining;

        echarts1 = this.$echarts.init(document.getElementById("bingtu"));
        var option = {
          tooltip: {},
          legend: {
            show: false,
            orient: "",
            x: "center", // 可设定图例在左、右、居中
            y: "center", // 可设定图例在上、下、居中
            left: "right",
          },
          series: [
            {
              type: "pie",
              radius: ["40%", "70%"],
              avoidLabelOverlap: true,
              itemStyle: {
                borderRadius: 5,
              },
              label: {
                show: true,
                normal: {
                  textStyle: {
                    color: "#ffffff", // 提示文字颜色
                    fontSize: 16, // 提示文字大小
                  },
                },
              },

              emphasis: {
                label: {
                  show: true,
                  fontSize: 20,
                  fontWeight: "bold",
                },
              },
              labelLine: {
                normal: {
                  length: 5,
                },
              },
              data: this.bingshuzhi,
            },
          ],
        };
        echarts1.setOption(option);
      });
    },
    selectItem(index) {
      this.selectedIndex = index;
      console.log("Clicked div index:", index);
      console.log("图片列表切换");
      this.bigImg = this.bigImgList[index];
    },
    getPatrolTaskPic() {
      console.log("图片列表");
      get("/threeBigscreen/getPatrolTaskPic", {
        robotId: this.robotId,
      }).then((res) => {
        this.timeList = res.data.map((item) => item.startTime);
        this.bigImgList = res.data.map(dataItem => {
          return dataItem.list.map(item => "http://114.132.232.205:8087" + item.pic);
        });
        this.bigImg = this.bigImgList[0];
      });
    },
    viewPhotoFalse() {
      this.bgDiog = false;
    },
    viewPhoto() {
      this.bgDiog = true;
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.swiper;
        const swiperThumbs = this.$refs.swiperThumbs.swiper;
        swiperTop.controller.control = swiperThumbs;
        swiperThumbs.controller.control = swiperTop;
      });
    },
    hourTimePoint() {
      this.items.forEach((item) => {
        const dateString = item.createTime;
        const dateObj = new Date(dateString);

        const hour = dateObj.getHours();
        const minute = dateObj.getMinutes();

        item.hourPoint = "left:" + (((hour * 60 + minute) / 1440) * 1200).toFixed(2) + "px";

      });
    },
    showPopup(item) {
      this.showPopupFlag = true;
      this.carSpaceTime.time = item.createTime; // 替换为你想要展示的字段
      this.carSpaceTime.imgSrcUrl = "http://114.132.232.205:8087" + item.pic;
      this.carSpaceTime.carType = item.isOwner;
      this.carSpaceTime.carNo = item.carNo;
    },
    hidePopup() {
      this.showPopupFlag = false;
    },
    jianting() {
      console.log(this.carSpace.length);
      if (this.carSpace.length == 0) {
        this.showTrue = true;
        console.log(this.carSpace);
      }
    },
    searchSpace() {
      if (this.carSpace.length != 0) {
        get("/threeBigscreen/getSpotInfo", {
          spotNo: this.carSpace,
        }).then((res) => {
          if (res.data.parkX1 == null) {
            alert("暂无此车位信息");
            return;
          } else {
            this.basicInformation.spotNo = this.carSpace;
            this.basicInformation.spaceStats = res.data.isOwner;
            this.basicInformation.useSituation = res.data.isLease;
            this.basicInformation.earningsRate = res.data.income;
            this.basicInformation.useRate = res.data.use;
            this.items = res.data.patrolList;
            this.vehiclePosition = res.data;

            this.hourTimePoint();
            this.showTrue = false;
          }
        });
      } else {
        alert("请输入车位");
        this.showTrue = true;
        // this.parkInfo();
      }
    },
    getTime2() {
      var date = new Date();
      var year = date.getFullYear();
      var mon = date.getMonth() + 1;
      var da = date.getDate(); //获取当前日

      var day = date.getDay();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var submitTime = "";
      submitTime += year + "-";
      if (mon >= 10) {
        // submitTime += mon + "-";
      } else {
        mon = "0" + mon;
      }
      if (da >= 10) {
        // submitTime += day;
      } else {
        da = "0" + da;
      }
      submitTime += " ";
      if (h >= 10) {
        // submitTime += h + ":";
      } else {
        h = "0" + h;
      }
      if (m >= 10) {
        // submitTime += m;
      } else {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      var weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );

      this.y3 = h + ":" + m;
    },
    getTime() {
      var date = new Date();
      var year = date.getFullYear();
      var mon = date.getMonth() + 1;
      var da = date.getDate(); //获取当前日

      var day = date.getDay();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var submitTime = "";
      submitTime += year + "-";
      if (mon >= 10) {
        // submitTime += mon + "-";
      } else {
        mon = "0" + mon;
      }
      if (da >= 10) {
        // submitTime += day;
      } else {
        da = "0" + da;
      }
      submitTime += " ";
      if (h >= 10) {
        // submitTime += h + ":";
      } else {
        h = "0" + h;
      }
      if (m >= 10) {
        // submitTime += m;
      } else {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      var weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );

      this.y1 = year + "年" + mon + "月" + da + "日";
      this.y2 = weeks[day] + " " + h + ":" + m + ":" + s;
      this.nowTime = (((h * 60 + m) / 1440) * 1200).toFixed(2);
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  position: relative;
  width: 1980px;
  height: 1080px;
  overflow: hidden;
}
.shouzhi {
  cursor: pointer;
}
.bingtu {
  width: 500px;
  height: 265px;
}
.left2center_col3table {
  height: 230px;

  ::v-deep .header-item {
    font-size: 20px !important;
    font-family: SourceHanSansSC-Bold !important;
    font-weight: bold !important;
    color: rgba(0, 255, 246, 1);
    background-color: #1b569b;
  }
  ::v-deep .row-item {
    color: #ffffff;
    // color: #90a9c8;
    font-size: 20px !important;
    font-family: SourceHanSansSC-Regular !important;

    // margin-bottom: 12px !important;
  }
}
.homeBtn {
  color: #ffffff;
  position: absolute;
  left: 1800px;
  top: 80px;
  width: 100px;
  height: 40px;
  background: url("../assets/按钮.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.leftBtn {
  color: #ffffff;
  position: absolute;
  left: 20px;
  top: 80px;
  width: 100px;
  height: 40px;
  background: url("../assets/按钮.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.text_01 {
  width: 146px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}
@font-face {
  font-family: YouSheBiaoTiHei;
  src: url("../assets/youshe.ttf");
}
@font-face {
  font-family: PangMenZhengDao;
  src: url("../assets/pangmenzhengdao.ttf");
}
body * {
  box-sizing: border-box;
  flex-shrink: 0;
}
body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
}
input {
  background-color: transparent;
  border: 0;
}
button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}
.van-nav-bar__left:active,
.van-nav-bar__right:active {
  opacity: 1;
}
[class*="van-"]::after {
  border-bottom: 0;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}

.group_1 {
  position: relative;
  width: 1980px;
  height: 1080px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psmkx3n475l47874ituuyor41z2vtdms0qzf0057ffb-c5f1-4e5c-930f-67bcd3d4e41f)
    100% no-repeat;
  background-size: 100% 100%;
}

.block_1 {
  width: 1923px;
  height: 105px;
}

.block_2 {
  width: 350px;
  height: 43px;
  margin-top: 38px;
}

.image_1 {
  width: 288px;
  height: 3px;
}

.text-wrapper_1 {
  width: 339px;
  height: 19px;
  margin: -30px 0 10px 11px;
}

.text_1 {
  width: 146px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text_2 {
  width: 177px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text-wrapper_2 {
  height: 90px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pskce9oynmb1nxwh3w24tj2mtimrpcjhw6128333e-e61e-452b-81d5-1513113f6d49) -6px -6px
    no-repeat;
  background-size: 1345px 103px;
  margin-left: -55px;
  width: 1332px;
}

.text_3 {
  text-shadow: 0px 0px 13px rgba(23, 125, 230, 0.38);
  width: 447px;
  height: 51px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 70px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 70px;
  margin: 20px 0 0 439px;
}

.block_3 {
  width: 288px;
  height: 89px;
  margin: 18px 0 0 7px;
}

.section_1 {
  width: 281px;
  height: 41px;
}

.image_2 {
  width: 82px;
  height: 41px;
}

.text_4 {
  width: 170px;
  height: 34px;
  overflow-wrap: break-word;
  color: rgba(13, 204, 255, 1);
  font-size: 45px;
  font-family: PangMenZhengDao;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 46px;
  margin-top: 6px;
  letter-spacing: -0.05em;
}

.text_5 {
  width: 213px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
  margin: 23px 0 0 75px;
}

.block_4 {
  position: relative;
  width: 1930px;
  height: 655px;
  margin: 21px 0 0 25px;
}

.box_1 {
  width: 215px;
  height: 35px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psgtb4lwe0kiryledskbk55dubo9eby8k1f9b7da67-96a9-49b0-9244-aeb7f38517c5)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 620px 0 0 22px;
}

.text_6 {
  width: 64px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(230, 230, 230, 1);
  font-size: 14px;
  font-family: SourceHanSansSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 11px 0 0 10px;
}

.image-wrapper_1 {
  height: 35px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psanoebd7hy9vcwvzhvtd6hkcauwztlelcad6a50dce-c3c2-4a7c-a72f-5fb9d06cba62) -1px
    0px no-repeat;
  background-size: 45px 35px;
  margin-left: 24px;
  width: 44px;
}

.thumbnail_1 {
  width: 18px;
  height: 17px;
  margin: 9px 0 0 13px;
}

.image-text_1 {
  width: 173px;
  height: 27px;
  margin: 626px 0 0 417px;
}

.label_1 {
  width: 28px;
  height: 27px;
}

.text-group_1 {
  width: 138px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 6px;
}

.image-text_2 {
  height: 26px;
  width: 612px;
  margin: 617px 306px 0 155px;
}

.text-wrapper_3 {
  width: 578px;
  height: 26px;
  margin-left: 34px;
}

.text-group_2 {
  width: 578px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.group_2 {
  width: 14px;
  height: 15px;
  margin: -21px 0 6px 0;
}

.image-wrapper_2 {
  height: 15px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps1nuz5l8q91g6p3lzfp8sbjpc5w1qjpsuec756629-e71c-4859-b745-63a970ac6406)
    100% no-repeat;
  background-size: 100% 100%;
  width: 14px;
}

.thumbnail_2 {
  width: 14px;
  height: 15px;
}

.box_2 {
  position: absolute;
  left: 0;
  top: 0;
  width: 1870px;
  height: 620px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psppnd05k5xhaxd8265dfy524o9v8pwcy6ifeed03d3-86b0-4233-84bd-ba2ced9cf320)
    100% no-repeat;
  background-size: 100% 100%;
}

.text-wrapper_4 {
  height: 41px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psqt7esss2y22f2skrfupiturjdm0yed1ica63e4db-19a0-4050-8a7c-50b2e4dfa987)
    100% no-repeat;
  background-size: 100% 100%;
  width: 380px;
  margin: 19px 0 0 760px;
}

.text_7 {
  width: 284px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin: 11px 0 0 30px;
}

.image_3 {
  width: 217px;
  height: 229px;
  margin: 237px 0 94px 856px;
}

.image_4 {
  margin: auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.block_5 {
  width: 1817px;
  height: 246px;
  margin: 22px 0 29px 47px;
}

.group_3 {
  width: 801px;
  height: 232px;
  margin-top: 14px;
  border: 2px solid rgba(0, 255, 246, 1);
}

.text-wrapper_5 {
  width: 801px;
  height: 29px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psssx44q8qjcg73a3zkq2z0ea5bvk08mv9l19a010cb-fff1-4973-90c8-cdaf41cd153a) -1px
    0px no-repeat;
  background-size: 803px 29px;
}

.text_8 {
  width: 47px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 0 0 33px;
}

.text_9 {
  width: 63px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 0 0 254px;
}

.text_10 {
  width: 63px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 85px 0 256px;
}

.section_2 {
  height: 204px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps6ga9fag3c1ongkynifbzgjwx8ak6sb0bca11e7893-870a-4a02-a990-821771ee7540)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: -1px;
  width: 801px;
}

.text-wrapper_6 {
  width: 669px;
  height: 20px;
  margin: 14px 0 0 33px;
}

.text_11 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_12 {
  width: 40px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 222px;
}

.text_13 {
  width: 50px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 278px;
}

.text-wrapper_7 {
  width: 650px;
  height: 20px;
  margin: 17px 0 0 33px;
}

.text_14 {
  width: 139px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 1px;
}

.text_15 {
  width: 31px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 163px;
}

.text_16 {
  width: 31px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 286px;
}

.text-wrapper_8 {
  width: 650px;
  height: 20px;
  margin: 17px 0 0 33px;
}

.text_17 {
  width: 139px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 1px;
}

.text_18 {
  width: 31px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 163px;
}

.text_19 {
  width: 31px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 286px;
}

.text-wrapper_9 {
  width: 650px;
  height: 20px;
  margin: 17px 0 0 33px;
}

.text_20 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_21 {
  width: 180px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(230, 230, 230, 1);
  font-size: 14px;
  font-family: SourceHanSansSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 8px 0 0 10px;
}

.text_22 {
  width: 31px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 286px;
}

.text-wrapper_10 {
  width: 650px;
  height: 20px;
  margin: 19px 0 20px 33px;
}

.text_23 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_24 {
  width: 31px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 223px;
}

.text_25 {
  width: 31px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 286px;
}

.group_4 {
  width: 6px;
  height: 192px;
  margin: 8px 0 0 163px;
}

.box_3 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
}

.box_4 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 31px;
}

.box_5 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 32px;
}

.box_6 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 31px;
}

.box_7 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 31px;
}

.box_8 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 31px;
}

.text-wrapper_11 {
  width: 120px;
  height: 205px;
  margin: 1px 0 0 17px;
}

.text_26 {
  width: 119px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_27 {
  width: 117px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 18px 0 0 2px;
}

.text_28 {
  width: 78px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 18px 0 0 1px;
}

.text_29 {
  width: 118px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 18px 0 0 1px;
}

.text_30 {
  width: 98px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 18px 0 0 1px;
}

.text_31 {
  width: 99px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 18px;
}

.text-wrapper_12 {
  width: 34px;
  height: 202px;
  margin: 3px 0 0 22px;
}

.text_32 {
  width: 34px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_33 {
  width: 34px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 21px;
}

.text_34 {
  width: 34px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 22px;
}

.text_35 {
  width: 34px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 21px;
}

.text_36 {
  width: 34px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 21px;
}

.text_37 {
  width: 34px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 21px;
}

.group_5 {
  width: 6px;
  height: 118px;
  margin: 8px 0 0 54px;
}

.box_9 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
}

.box_10 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 31px;
}

.box_11 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 32px;
}

.box_12 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 31px;
}

.text-wrapper_13 {
  width: 159px;
  height: 132px;
  margin: 1px 0 0 17px;
}

.text_38 {
  width: 118px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_39 {
  width: 157px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 17px 0 0 2px;
}

.text_40 {
  width: 117px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 18px 0 0 2px;
}

.text_41 {
  width: 139px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 17px;
}

.text-wrapper_14 {
  width: 34px;
  height: 128px;
  margin: 3px 0 0 21px;
}

.text_42 {
  width: 34px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_43 {
  width: 34px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 21px;
}

.text_44 {
  width: 34px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 22px;
}

.text_45 {
  width: 34px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 21px;
}

.group_6 {
  position: relative;
  width: 500px;
  height: 275px;
  left: -40px;
}

.text_46 {
  width: 100%;
  height: 20px;
  text-align: center;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;

  white-space: nowrap;
  line-height: 20px;
}

.box_13 {
  width: 318px;
  height: 78px;
  margin-top: 59px;
}

.text-wrapper_15 {
  width: 62px;
  height: 16px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: DIN-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 41px;
}

.text_47 {
  width: 62px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 254, 1);
  font-size: 16px;
  font-family: DIN-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.text_48 {
  width: 62px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 254, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.section_3 {
  width: 71px;
  height: 73px;
  margin-left: 30px;
}

.image-wrapper_3 {
  height: 45px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psovorwhp3mreayfcya5r6zwcuci6re0eie5b536d2-2185-4c8b-a8a4-c473aea97418) -1px -1px
    no-repeat;
  background-size: 61px 46px;
  margin-left: 11px;
  width: 60px;
}

.image_5 {
  width: 24px;
  height: 9px;
  margin: -5px 0 0 9px;
}

.image-wrapper_4 {
  height: 36px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps9x37c31j7e6jw6id7ddpppgbv74a18yt4e28cf73-1a3c-4c0c-919f-bce1270c0733)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: -8px;
  width: 25px;
}

.image_6 {
  width: 24px;
  height: 9px;
  margin: 11px 0 0 -23px;
}

.label_2 {
  width: 31px;
  height: 25px;
  margin-left: 2px;
}

.section_4 {
  width: 81px;
  height: 30px;
  margin: 48px 0 0 41px;
}

.text-wrapper_16 {
  width: 78px;
  height: 16px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: DIN-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-left: 3px;
}

.text_49 {
  width: 78px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 254, 1);
  font-size: 16px;
  font-family: DIN-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.text_50 {
  width: 78px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 254, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.image_7 {
  width: 23px;
  height: 9px;
  margin-top: 5px;
}

.text-wrapper_17 {
  width: 79px;
  height: 16px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: DIN-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 55px 0 0 21px;
}

.text_51 {
  width: 79px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 254, 1);
  font-size: 16px;
  font-family: DIN-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.text_52 {
  width: 79px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 254, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.box_14 {
  position: absolute;
  left: 40px;
  top: 53px;
  width: 217px;
  height: 29px;
}

.text-wrapper_18 {
  width: 72px;
  height: 16px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: DIN-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 11px;
}

.text_53 {
  width: 72px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 254, 1);
  font-size: 16px;
  font-family: DIN-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.text_54 {
  width: 72px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 254, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.box_15 {
  width: 70px;
  height: 29px;
}

.text-wrapper_19 {
  width: 63px;
  height: 16px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: DIN-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-left: 7px;
}

.text_55 {
  width: 63px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 254, 1);
  font-size: 16px;
  font-family: DIN-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.text_56 {
  width: 63px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 254, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.image_8 {
  width: 23px;
  height: 9px;
  margin-top: 4px;
}

.block_6 {
  border-radius: 50%;
  position: absolute;
  left: 1007.5px;
  top: 807.5px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.block_7 {
  border-radius: 50%;
  position: absolute;
  left: 1007.5px;
  top: 846px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.block_8 {
  border-radius: 50%;
  position: absolute;
  left: 1007.5px;
  top: 884px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.block_9 {
  border-radius: 50%;
  position: absolute;
  left: 1007.5px;
  top: 921px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.block_10 {
  border-radius: 50%;
  position: absolute;
  left: 1007.5px;
  top: 809px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.block_11 {
  border-radius: 50%;
  position: absolute;
  left: 1007.5px;
  top: 846px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.block_12 {
  border-radius: 50%;
  position: absolute;
  left: 1007.5px;
  top: 884px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.block_13 {
  border-radius: 50%;
  position: absolute;
  left: 1007.5px;
  top: 921px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.block_14 {
  border-radius: 50%;
  position: absolute;
  left: 1037px;
  top: 958px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.block_15 {
  border-radius: 50%;
  position: absolute;
  left: 1037px;
  top: 995px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.image_9 {
  position: absolute;
  left: 1806px;
  top: 893px;
  width: 47px;
  height: 107px;
}

.image-wrapper_5 {
  height: 70px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psqm8rn8sw3f7it9lrapjgog2w2v64yju3p39db4bc1-4cfe-47c4-9c16-ffe492ba9df4)
    100% no-repeat;
  background-size: 100% 100%;
  width: 128px;
  position: absolute;
  left: 1708px;
  top: 959px;
}

.image_10 {
  width: 23px;
  height: 9px;
  margin: 59px 0 0 13px;
}

.xgroup_4 {
  height: 224px;
  // background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psuzs6s0r49u840hex8hj9zjdpeku5ti6o6fb46737a-dccb-4934-9f57-fd5433697278)
  //   100% no-repeat;
  background-size: 100% 100%;
  width: 290px;
  position: absolute;
  left: 47px;
  top: 810px;
  justify-content: flex-center;
  border: 1px solid rgba(0, 255, 246, 1);
}

.xtext-wrapper_3 {
  width: 143px;
  height: 19px;
  margin: 25px 0 0 29px;
}

.xtext_7 {
  width: 143px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.xbox_4 {
  width: 220px;
  height: 20px;
  margin: 22px 0 0 34px;
}

.xbox_5 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.xtext_8 {
  width: 78px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 18px;
}

.xtext_9 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 39px;
}

.xbox_6 {
  width: 204px;
  height: 20px;
  margin: 18px 0 0 34px;
}

.xgroup_5 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.xtext_10 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 17px;
}

.xtext_11 {
  width: 59px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 42px;
}

.xbox_7 {
  width: 183px;
  height: 20px;
  margin: 17px 0 0 34px;
}

.xsection_6 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.xtext_12 {
  width: 58px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 18px;
}

.xtext_13 {
  width: 42px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 59px;
}

.xbox_8 {
  width: 183px;
  height: 20px;
  margin: 18px 0 25px 34px;
}

.xbox_9 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.xtext_14 {
  width: 59px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 17px;
}

.xtext_15 {
  width: 42px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 59px;
}

.xbox_10 {
  border-radius: 50%;
  position: absolute;
  left: 30px;
  top: 69px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.xbox_11 {
  border-radius: 50%;
  position: absolute;
  left: 30px;
  top: 107px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.xbox_12 {
  border-radius: 50%;
  position: absolute;
  left: 30px;
  top: 144px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.xbox_13 {
  border-radius: 50%;
  position: absolute;
  left: 30px;
  top: 182px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}
.xtimeLine {
  width: 1500px;
  height: 224px;

  position: absolute;
  left: 360px;
  top: 810px;
}
.allDay {
  position: absolute;
  left: 100px;
  top: 30px;
  width: 1200px;
  height: 18px;
  background-color: #115c8d;
  border: 2px solid rgba(0, 255, 246, 1);
  border-radius: 10px;
}
.nowTime {
  position: absolute;
  left: -1px;
  top: -1px;
  height: 17px;
  background-color: rgba(0, 255, 246, 1);
  border: 2px solid rgba(0, 255, 246, 1);
  border-radius: 10px;
}
.titleToday {
  color: #ffffff;
  position: absolute;
  top: -35px;
  left: 500px;
  font-size: 30px;
}
.timePoint {
  width: 10px;
  height: 10px;
  background-color: #ffcc00;
  border-radius: 15px;
  position: absolute;
  top: 4px;
}
.popupCar {
  width: 600px;
  height: 150px;
  color: #ffffff;
  position: absolute;
  left: 300px;
  top: 70px;
  border: 1px solid rgba(0, 255, 246, 1);
}
.carPhoto {
  width: 200px;
  height: 150px;
  position: absolute;
}
.pzTime {
  position: absolute;
  left: 220px;
}
.carNoNo {
  position: absolute;
  left: 220px;
  top: 100px;
}
.carType {
  position: absolute;
  left: 220px;
  top: 50px;
}
.photobox_6 {
  height: 698px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pshs1blgwaae844zx143p44xs06lf21j72adc7a300a-3207-4c1f-834d-21fff366e06f) -1px
    0px no-repeat;
  background-size: 1047px 698px;
  width: 1045px;
  margin: 206px 0 0 450px;
  position: relative;
}

.photosection_2 {
  width: 987px;
  height: 34px;
  margin: 13px 0 0 34px;
}

.photoimage-wrapper_5 {
  height: 15px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psz8yhn9ft4rf7nl5mup7b5cr5sw3bzo23nbfe653c8-4811-46b4-878c-df981d47a5f8)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 13px;
  width: 14px;
}

.photothumbnail_3 {
  width: 14px;
  height: 15px;
}

.phototext_26 {
  width: 533px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
  margin: 9px 0 0 9px;
}

.photolabel_6 {
  width: 25px;
  height: 25px;
  margin-left: 406px;
}

.photosection_3 {
  width: 922px;
  height: 437px;
  margin: 22px 0 0 60px;
}

.photoimage-wrapper_6 {
  width: 682px;
  height: 437px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/f2d6febe052c439a9e34d68bc7ab0867_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
}

.photoimage_12 {
  width: 22px;
  height: 20px;
  margin: 212px 0 0 11px;
}

.photoimage_13 {
  width: 22px;
  height: 20px;
  margin: 217px 14px 0 613px;
}

.photobox_7 {
  width: 188px;
  height: 356px;
  position: absolute;
  left: 800px;
  top: 70px;
}

.phototext_27 {
  width: 70px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(179, 204, 230, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.photoblock_9 {
  height: 322px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pssor3pfj6tsg3esin6le1c28t7g1xo44xq5fe4f57a-909c-43c7-9b3c-dafe2d9f0d21)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 17px;
  width: 228px;
}

.photogroup_15 {
  width: 162px;
  height: 227px;
  margin: 12px 0 0 18px;
}

.phototext-wrapper_11 {
  width: 97px;
  height: 222px;
}

.phototext_28 {
  width: 97px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(249, 212, 10, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.phototext_29 {
  width: 91px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 19px;
}

.phototext_30 {
  width: 91px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 20px;
}

.phototext_31 {
  width: 91px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 19px;
}

.phototext_32 {
  width: 91px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 20px;
}

.phototext_33 {
  width: 91px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 19px;
}

.phototext_34 {
  width: 91px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 20px;
}

.photophotothumbnail_4 {
  width: 13px;
  height: 10px;
  margin: 3px 0 0 28px;
}

.photobox_8 {
  background-color: rgba(0, 255, 246, 0.16);
  border-radius: 2px;
  height: 224px;
  width: 6px;
  margin: 3px 0 0 18px;
}

.photoblock_10 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 3px;
  width: 6px;
  height: 85px;
}

.phototext-wrapper_12 {
  width: 91px;
  height: 15px;
  margin: 15px 0 0 18px;
}

.phototext_35 {
  width: 91px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.phototext-wrapper_13 {
  width: 91px;
  height: 15px;
  margin: 20px 0 18px 18px;
}

.phototext_36 {
  width: 91px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.photosection_4 {
  width: 1004px;
  height: 109px;
  margin: 35px 0 48px 19px;
}

.photoimage_14 {
  width: 22px;
  height: 20px;
  margin-top: 50px;
}

.photoimage-wrapper_7 {
  width: 924px;
  height: 109px;
  margin-left: 19px;
}

.photoimage_15 {
  width: 170px;
  height: 109px;
  margin-right: 19px;
}

.photoimage_16 {
  width: 22px;
  height: 20px;
  margin: 56px 0 0 17px;
}
.restartWinBg {
  position: absolute;
  width: 1980px;
  height: 1080px;
  background-color: #0006467f;
  // opacity: 0.3;
}
.more-text-content {
  width: 220px;
  height: 320px;
  overflow: auto;

  box-sizing: border-box;
  padding: 10px 0px 10px 20px;
  .details-content {
    width: 100%;
    height: auto;
    font-size: 16px;
    line-height: 30px;

    color: #fff;
    box-sizing: border-box;
    .details-conten-item {
      cursor: pointer;
    }
    .selected {
      color: yellow;
      font-weight: bold;
    }
  }
}
h3 {
  margin: 20px 0 0 10px;
}
.thumb-example {
  width: 750px;
  position: absolute;
  left: 20px;
  top: 70px;
  // background: #000;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
}
.gallery-top {
  // height: 80% !important;
  height: 500px;
  width: 100%;
}
.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0px;
  width: 750px;
  margin-left: 2px;
  .swiper-button-next {
    right: 0px;
  }
  .swiper-button-prev {
    left: 0px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    width: 45px;
    text-align: center;
    height: 101px;
    top: 26%;
    div {
      margin-top: 30px;
      background: rgb(207, 205, 205);
      height: 45px;
      border-radius: 50%;
      img {
        margin: 7px 0 0 2px;
        width: 30px;
      }
    }
  }
  .swiper-button-next:hover div {
    background: rgb(189, 186, 186);
  }
  .swiper-button-prev:hover div {
    background: rgb(189, 186, 186);
  }
}
.gallery-thumbs .swiper-slide {
  width: 20%;
  height: 80px;
  // opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  border: 2px solid red;
}
.first-item {
  color: yellow;
  font-weight: bold;
}
</style>
